// Real Google Reviews for Charter Roofings

export const reviewsData = {
  en: [
    {
      name: 'Nancy Hensen',
      company: 'Homeowner',
      rating: 5,
      text: 'We highly recommend him. We saw him in our street next door, spoke to him, and he was able to inspect our roof quickly. We had good communication; he takes photos and videos of your roof to show before and after. Clear agreements, spontaneous, and friendly. He\'s also a hard worker; everything was inspected, discussed, and completed within a week. Simply excellent!',
      date: 'Aug 2025',
      project: 'Roof Inspection & Repair',
    },
    {
      name: 'Ilan Smeyatsky',
      company: 'Homeowner',
      rating: 5,
      text: 'Joe is a very friendly and knowledgeable contractor who was able to easily and quickly assess a quite serious roof leak we had at our house. He explained all the work he did and how he was able to repair the issue. Also very reasonably priced! Speaks English and Dutch.',
      date: 'Jan 2026',
      project: 'Roof Leak Repair',
    },
    {
      name: 'Lotte Wiering',
      company: 'Homeowner',
      rating: 5,
      text: 'I would definitely recommend Charter Roofings! We had a leak on our roof. Joe was able to come by quickly and immediately knew what was wrong. We received a quote the same day. Clear and fast communication! Due to our satisfaction, we also had our shed roof redone to accommodate future solar panels. Thanks!',
      date: 'Oct 2025',
      project: 'Roof Leak & Shed Roof',
    },
    {
      name: 'Lei Thewessem',
      company: 'Homeowner',
      rating: 5,
      text: 'I would definitely recommend Joe. He\'s very professional, works with a smile, and left the work area spotlessly clean. Charter Roofings\' office side is also well-organized, with clear and prompt communication. Update: Joe also helped me get a waterproof roof in my new house. Once again, top-notch service!',
      date: 'Jan 2026',
      project: 'Roof Waterproofing',
    },
    {
      name: 'Arjen L',
      company: 'Homeowner',
      rating: 5,
      text: 'Awesome guy! Hard worker, cheerful, and meticulous! We received a comprehensive quote with a thorough inspection and visuals beforehand. We\'re very pleased and will definitely use your services again for our shed! Thanks so much for all your time and effort! Cheers, buddy! You\'re a fantastic bloke, thanks so much for all your hard work!',
      date: 'Jan 2026',
      project: 'Roof Inspection & Quote',
    },
    {
      name: 'Matthys Gerber',
      company: 'Homeowner - Zaandam',
      rating: 5,
      text: 'Excellent service. Prompt and perfect. Adam is courteous and friendly. Warmly recommended.',
      date: 'Sep 2025',
      project: 'Roofing Service',
    },
  ],
  nl: [
    {
      name: 'Nancy Hensen',
      company: 'Huiseigenaar',
      rating: 5,
      text: 'We bevelen hem van harte aan. We zagen hem in onze straat bij de buren, spraken hem aan en hij kon ons dak snel inspecteren. We hadden goede communicatie; hij maakt foto\'s en video\'s van je dak om voor en na te laten zien. Duidelijke afspraken, spontaan en vriendelijk. Hij is ook een harde werker; alles was binnen een week geïnspecteerd, besproken en voltooid. Gewoon uitstekend!',
      date: 'Aug 2025',
      project: 'Dakinspectie & Reparatie',
    },
    {
      name: 'Ilan Smeyatsky',
      company: 'Huiseigenaar',
      rating: 5,
      text: 'Joe is een zeer vriendelijke en deskundige aannemer die een behoorlijk ernstige daklekkage bij ons huis gemakkelijk en snel kon beoordelen. Hij legde al het werk uit dat hij deed en hoe hij het probleem kon repareren. Ook zeer redelijk geprijsd! Spreekt Engels en Nederlands.',
      date: 'Jan 2026',
      project: 'Daklekkage Reparatie',
    },
    {
      name: 'Lotte Wiering',
      company: 'Huiseigenaar',
      rating: 5,
      text: 'Ik zou Charter Roofings zeker aanraden! We hadden een lek op ons dak. Joe kon snel langskomen en wist meteen wat er aan de hand was. We ontvingen dezelfde dag nog een offerte. Duidelijke en snelle communicatie! Vanwege onze tevredenheid hebben we ook ons schuurtak laten vernieuwen om toekomstige zonnepanelen te kunnen plaatsen. Bedankt!',
      date: 'Okt 2025',
      project: 'Daklek & Schuurdak',
    },
    {
      name: 'Lei Thewessem',
      company: 'Huiseigenaar',
      rating: 5,
      text: 'Ik zou Joe zeker aanraden. Hij is zeer professioneel, werkt met een glimlach en liet het werkgebied brandschoon achter. De kantoorkant van Charter Roofings is ook goed georganiseerd, met duidelijke en snelle communicatie. Update: Joe heeft me ook geholpen een waterdicht dak te krijgen in mijn nieuwe huis. Opnieuw eersteklas service!',
      date: 'Jan 2026',
      project: 'Dak Waterdicht Maken',
    },
    {
      name: 'Arjen L',
      company: 'Huiseigenaar',
      rating: 5,
      text: 'Geweldige vent! Harde werker, opgewekt en nauwkeurig! We ontvingen een uitgebreide offerte met een grondige inspectie en visueel materiaal van tevoren. We zijn zeer tevreden en zullen zeker weer gebruik maken van jullie diensten voor onze schuur! Heel erg bedankt voor al je tijd en moeite! Cheers, maat! Je bent een fantastische kerel, heel erg bedankt voor al je harde werk!',
      date: 'Jan 2026',
      project: 'Dakinspectie & Offerte',
    },
    {
      name: 'Matthys Gerber',
      company: 'Huiseigenaar - Zaandam',
      rating: 5,
      text: 'Uitstekende service. Snel en perfect. Adam is hoffelijk en vriendelijk. Van harte aanbevolen.',
      date: 'Sep 2025',
      project: 'Dakwerkzaamheden',
    },
  ],
};
